<template>
  <div class="mt-3">
    <div class="font-weight-bold font_size_1125rem v3_color_teal mb-3 border_bottom_1 border_bottom_light_teal">
      Number of Matches
    </div>
    <div
      class="px-3 border_2 rounded_0 border_light_teal v3_bg_teal_03 v3_color_white font_size_2500rem min_height_100 d-flex align-items-center justify-content-center"
    >
      <b-spinner
        v-if="loading"
        style="width: 3rem; height: 3rem;"
        class="v2_font_size_24"
      />
      <span v-else>{{ value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecruiterIcoMatching',
  props: {
    value: [Number, String],
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
